<template>
  <div>
    <px-selecao-fornecedor-chip v-for="fornecedor in fornecedoresVisiveis"
                                :key="fornecedor.id"
                                :fornecedor="fornecedor"
                                @remove="onRemoveItem"/>
    <px-selecao-fornecedores-selecionados-menu v-if="hasMenu"
                                                :fornecedores="fornecedores"
                                                @remove="onRemoveItem"/>
  </div>
</template>

<script>
import PxSelecaoFornecedorChip
  from '@/components/lista-selecao-fornecedor/PxSelecaoFornecedorChip.vue';
import PxSelecaoFornecedoresSelecionadosMenu
  from '@/components/lista-selecao-fornecedor/PxSelecaoFornecedoresSelecionadosMenu.vue';

const FORNECEDORES_VISIVEIS = 5;

export default {
  props: {
    fornecedores: {
      type: Array,
    },
  },
  computed: {
    fornecedoresVisiveis() {
      if (!this.fornecedores || !this.fornecedores.length) {
        return [];
      }
      return this.fornecedores.slice(0, FORNECEDORES_VISIVEIS);
    },
    hasMenu() {
      return this.fornecedores && this.fornecedores.length > FORNECEDORES_VISIVEIS;
    },
  },
  methods: {
    onRemoveItem(requisicaoProduto) {
      this.$emit('remove', requisicaoProduto);
    },
  },
  components: {
    PxSelecaoFornecedorChip,
    PxSelecaoFornecedoresSelecionadosMenu,
  },
};
</script>
